import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { LoadingSpinner } from './LoadingSpinner';

interface SurveyProtectedRouteProps {
	children: React.ReactNode;
}

export const SurveyProtectedRoute: React.FC<SurveyProtectedRouteProps> = ({ children }) => {
	const { isAuthenticated, isLoading } = useAuth();

	if (isLoading) {
		return <LoadingSpinner variant='fullscreen' message='Provera pristupa...' size='large' />;
	}

	if (!isAuthenticated) {
		return <Navigate to='/' replace />;
	}

	return <>{children}</>;
};
